import { TimelineSectionStatus } from "./timeline-section-status.enum";

export class TimelineSection {
  public sectionType: string;
  public sectionDate: string;
  public id: number;
  public status: TimelineSectionStatus;
  public placementId: number;
  public subject: string;
}
